import { createAction } from "@reduxjs/toolkit";
import {
  AddStoryViewType,
  DeleteStoryType,
  SetStoriesType,
  UpdateSeenStoryType,
  UpdateStoriesType,
  UpdateStoryViewType,
  SET_STORIES,
  UPDATE_STORIES,
  UPDATE_SEEN_STORY,
  DELETE_STORY,
  ADD_STORY_VIEW,
  UPDATE_STORY_VIEW,
} from "./types";

export const setStoriesList = createAction<SetStoriesType["payload"]>(SET_STORIES);
export const updateStoriesList = createAction<UpdateStoriesType["payload"]>(UPDATE_STORIES);
export const updateSeenStory = createAction<UpdateSeenStoryType["payload"]>(UPDATE_SEEN_STORY);
export const deleteStory = createAction<DeleteStoryType["payload"]>(DELETE_STORY);
export const addStoryView = createAction<AddStoryViewType["payload"]>(ADD_STORY_VIEW);
export const updateStoryView = createAction<UpdateStoryViewType["payload"]>(UPDATE_STORY_VIEW);
